(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noki-footer"] && !Shopify.designMode) return;
  try {
    
  const brigittaDialog = document.querySelector('#BrigittaAcademyDialog');
  if (brigittaDialog && !sessionStorage.getItem('brigitta_academy_popup_closed')) {
    window.setTimeout(() => {
      if (!brigittaDialog.open) brigittaDialog.showModal();
    }, 20000);
    const closeBrigittaDialog = () => {
      sessionStorage.setItem('brigitta_academy_popup_closed', '1');
      brigittaDialog.close();
    };
    brigittaDialog.querySelector('.nf-dialog-close').addEventListener('click', closeBrigittaDialog);
    brigittaDialog.addEventListener('click', (event) => {
      if (event.target === brigittaDialog) closeBrigittaDialog();
    });
    brigittaDialog.addEventListener('cancel', () => sessionStorage.setItem('brigitta_academy_popup_closed', '1'));
  }
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealItems = document.querySelectorAll('.nf-section, .nf-promo, .nf-faq, .nf-card, .nf-category');
    revealItems.forEach((item) => item.classList.add('nf-reveal'));
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nf-reveal-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noki-header"] && !Shopify.designMode) return;
  try {
    
  const updateBrigittaCartCount = async () => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await response.json();
      document.querySelectorAll('.nf-cart-count').forEach((badge) => { badge.textContent = cart.item_count; });
      document.querySelectorAll('.nf-cart-link').forEach((link) => { link.setAttribute('aria-label', `Panier, ${cart.item_count} article${cart.item_count === 1 ? '' : 's'}`); });
    } catch (error) {}
  };
  document.addEventListener('cart:update', updateBrigittaCartCount);
  document.addEventListener('cart:refresh', updateBrigittaCartCount);
  window.addEventListener('pageshow', updateBrigittaCartCount);

  } catch(e) { console.error(e); }
})();
})();
